var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main_box"},[_c('slider',{on:{"onVertifyDone":_vm.handleData}}),_c('span',[_vm._v(_vm._s(_vm.checkResult))]),_c('trackChart',{ref:"myChart"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }